module.exports = __webpack_public_path__ + "./images/dc4c4e94eea9a2c7708284cd48edecdd.webp";